// VisionStatement.jsx
import React from 'react';
import './VisionStatement.css'; // Import the CSS file

const VisionStatement = () => {
  return (
    <div className="vision-container">
      <div className="vision-content">
        <h1 className="vision-title">
          Our Vision<span className="vision-dot">.</span>
        </h1>
        
        <p className="vision-paragraph">
          Visionary parent company fostering an ecosystem of innovative ventures,<br/>
          rooted in collaboration, empowerment, and sustainable growth.
        </p>
        
        <p className="vision-paragraph">
          We planning to Organize the Home construction industry with various
          Platforms.
        </p>
      </div>
    </div>
  );
};

export default VisionStatement;